const color = require('color');
import { TRANSPARENCY_BREAKPOINT } from './constants';
export function isTransparent(value) {
    if (value) {
        try {
            return color(value).alpha() <= TRANSPARENCY_BREAKPOINT;
        }
        catch (error) { }
    }
    return false;
}
export function upgradeColor(value) {
    if (value) {
        if (value === 'transparent') {
            return '#FFFFFF';
        }
        try {
            return color(value).hex();
        }
        catch (error) { }
    }
    return value;
}
//# sourceMappingURL=upgrade-color.js.map